import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LeaveLiverWindow from '../components/LeaveLiverWindow';
import PlayerBrain from '../components/PlayerBrain';
import Comment from '../components/Comment';
import './Opening.modules.css'; // スタイルを分離して管理
import { checkInput, correctInput } from "../components/romajiUtils";
import { PRACTICE_MESSAGE } from "../constants/openingConstant"
import { SUPER_CHAT } from "../constants/gameConstant"
import { OpeningCommentBot } from "../components/CommentBot";

const Opening = () => {
  // 1回だけ実行するための状態管理
  const [hasTransitioned, setHasTransitioned] = useState(false);
  // ユーザーが入力中の文字列を管理するステート
  const [currentQuestion, setCurrentQuestion] = useState({});
  // ユーザーが入力中の文字列を管理するステート
  const [userInput, setUserInput] = useState("");

  // 画面遷移用のフック
  const navigate = useNavigate();
  // 参照保持するフック
  const refComment = useRef();
  const refLiverWindow = useRef();

  // 画面遷移時に1度だけ実行する処理
  useEffect(() => {
    if (!hasTransitioned) {
      startOpening();
      setHasTransitioned(true); // フラグを立てて再実行を防止
    }
  }, [hasTransitioned]);

  // カウントダウンが終了したときの処理
  const handleCountdownComplete = () => {
    exitOpening();
  };

  // 画面遷移時の初期化処理
  const startOpening = () => {
    setUserInput(""); // ユーザー入力をクリア
    setCurrentQuestion(PRACTICE_MESSAGE[0]); //問題を設定

    // コメントBOTの開始
    OpeningCommentBot({ comment: refComment.current });
  };

  // オープニングの開始待ち処理
  const waitOpening = () => {
    setUserInput("");
    setCurrentQuestion();

    // 同意した
    refLiverWindow.current.agreed();
  };

  // オープニングの終了処理
  const exitOpening = () => {
    // ゲーム画面に遷移
    navigate("/game");
  };

  // ユーザーの入力イベントを処理する関数
  const handleInputChange = (e) => {
    let newInput = e.target.value;
    if (currentQuestion == null) {
      return;
    }
    if (checkInput(currentQuestion?.ANSWER_ROM, newInput)) {
      newInput = correctInput(currentQuestion?.ANSWER_ROM, newInput);
      setUserInput(newInput);
      if (newInput.length === currentQuestion?.ANSWER_ROM.length) {
        // コメントの追加処理
        if (refComment.current) {
          refComment.current.addComment("フリスタオ", currentQuestion?.ANSWER_JP, SUPER_CHAT.PRICE_LEVEL_7);

          // 開始待ち
          waitOpening();
        }
      }
    }
  };

  return (
    <div className="opening-screen" >
      {/* ライバーの待機画面 */}
      <LeaveLiverWindow
        onComplete={handleCountdownComplete} ref={refLiverWindow} />

      {/* プレイヤーの入力欄 */}
      <PlayerBrain
        currentQuestion={currentQuestion}
        userInput={userInput}
        handleInputChange={handleInputChange}
      />

      {/* コメント欄 */}
      <Comment userInput={userInput} ref={refComment} />
    </div>
  );
};

export default Opening;
